export default __webpack_public_path__ + "static/media/1036.bb680629.png";